import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/20/solid";
import SecondaryButton from "./SecondaryButton";

export const PaginationRow = ({ totalPages, currentPage, setPage }) => {
  return (
    <div className="flex items-center justify-between w-full">
      <div>
        <SecondaryButton
          onClick={() => setPage(currentPage - 1)}
          disabled={currentPage === 1}
          type="button"
        >
          <ArrowLeftIcon className="size-4" />
        </SecondaryButton>
      </div>

      <div className="text-sm font-medium leading-tight text-gray-900">
        Page {currentPage} of {totalPages}
      </div>

      <div>
        <SecondaryButton
          onClick={() => setPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          type="button"
        >
          <ArrowRightIcon className="size-4" />
        </SecondaryButton>
      </div>
    </div>
  );
};
